import { FC } from "react";

import LoaderIcon from "@Icons/LoaderIcon";

import "./roadViewMap.scss";

export const RoadViewMap: FC<any> = ({ isMapLoaded }) => {
  if (!isMapLoaded)
    return (
      <div className="hello">
        <LoaderIcon />
      </div>
    );

  return <div id="map2" style={{ height: "100%", width: "100%", overflow: "hidden" }} />;
};

export default RoadViewMap;
